import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";
import { queryClient } from "../utils/graphql";

export const Signout: React.FC = () => {
  const { signOut } = useAuth();

  useEffect(() => {
    signOut().then(() => {
      queryClient.clear();
    });
  });

  return null;
};
